module.exports = __webpack_public_path__ + "static/media/1933701_charge_credit card_discover_payment_icon.464cbb77.svg";